import React from 'react';
import styled from 'astroturf/react';

import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Icon } from 'js/design_system/Icon';

import routes from 'js/core_pre_webpack/routes';

import { IconAnchor, IconContainer, IconLabel } from './buttonStyles';

export const grantsMarketingIconButton = (
  <ImpressionWatcher key="grantMultiplier" source="grantai.nav_button">
    <IconAnchor
      href={routes.grant_multiplier_landing_url({
        from_navbar: true,
        trigger: 'nav',
      })}
    >
      <IconContainer>
        <Icon name="paid" size={24} />
      </IconContainer>
      <IconLabel>Grants</IconLabel>
    </IconAnchor>
  </ImpressionWatcher>
);

// The "See grant matches" prominent button shown to premium users in the
// `control` arm of design_2026_q2_nav_redesign. The `redesign` arm shows the
// grants icon (grantsMarketingIconButton) to everyone instead. Delete the
// losing arm's path when the test concludes.
export function GrantsMarketingButton() {
  return (
    <ImpressionWatcher source="grantai.prominent_nav_button">
      <Container>
        <ButtonLink
          href={routes.grant_multiplier_landing_url({
            from_navbar: true,
            trigger: 'nav',
          })}
          icon="paid"
          size="sm"
        >
          See grant matches
        </ButtonLink>
      </Container>
    </ImpressionWatcher>
  );
}

// Hide button on certain screen widths so it doesn't cut off the search bar placeholder text
const Container = styled.div`
  @media (max-width: 417px), (min-width: 769px) and (max-width: 991px) {
    display: none;
  }
`;
